import { useAtomValue } from "jotai";
import { mapExpenseBreakdown } from "web_myplann/Finances/Helpers/mapExpenseBreakdown";
import { mapIncomeBreakdown } from "web_myplann/Finances/Helpers/mapIncomeBreakdown";
import { sumIncomeAmounts } from "web_myplann/Finances/Helpers/sumIncomeAmounts";
import { sumMonthlyPayments } from "web_myplann/Finances/Helpers/sumMonthlyPayments";
import { useFinanceEntries } from "web_myplann/Finances/Hooks/useFinanceEntries";
import { useSyncFinanceState } from "web_myplann/Finances/Hooks/useSyncFinanceState";
import { financeState } from "web_myplann/Finances/State/FinanceAtom";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";

type UseFinanceDataParams = {
	hydrateDraft?: boolean;
};

export const useFinanceData = ({
	hydrateDraft = true,
}: UseFinanceDataParams = {}) => {
	const { t } = useResource();

	const {
		incomeEntries: fetchedIncome,
		expenseEntries: fetchedExpenses,
		isLoading,
		isError,
	} = useFinanceEntries();

	useSyncFinanceState(hydrateDraft);

	const finance = useAtomValue(financeState);

	const incomeEntries =
		finance.income.length > 0 ? finance.income : fetchedIncome;
	const expenseEntries =
		finance.expenses.length > 0 ? finance.expenses : fetchedExpenses;

	const hasStoredData =
		finance.income.length > 0 || finance.expenses.length > 0;

	return {
		isLoading: !hasStoredData && isLoading,
		isError: !hasStoredData && isError,
		totalIncome: sumIncomeAmounts(incomeEntries),
		totalExpenses: sumMonthlyPayments(expenseEntries),
		incomeBreakdown: mapIncomeBreakdown(incomeEntries),
		expenseBreakdown: mapExpenseBreakdown(expenseEntries, t),
	};
};
